import { render } from "./FaqItem.vue?vue&type=template&id=0c54c94e"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"
script.render = render

export default script